module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('echart', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.option
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-48003020!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StatChart.vue
// module id = 7TL4
// module chunks = 4